import React, { PureComponent } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import Collapse from '@material-ui/core/Collapse';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';

const Root = styled.div.withConfig({ componentId: 'sc-4uxgvt-0' })`
  background-color: ${colors.blite};
  padding: 6px 8px 8px;
  border-radius: 4px;
  line-height: 1;
`;

const Copy = styled.span.withConfig({ componentId: 'sc-4uxgvt-1' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.extraSmall};
`;

type Props = {
  insuranceCard?: object;
  t: TFunction<'addInsurance'>;
};

class HelpfulHint extends PureComponent<Props> {
  hasError = () => {
    const { insuranceCard } = this.props;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return insuranceCard.front.error || insuranceCard.back.error;
  };

  render() {
    const { t } = this.props;
    return (
      <Collapse appear in={this.hasError()} timeout="auto">
        <Root>
          <Copy>{t('helpfulHint')}</Copy>
        </Root>
      </Collapse>
    );
  }
}

export default withTranslation('addInsurance')(HelpfulHint);
